import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from 'lucide-react'

import { Button } from '@/shared/ui/primitives'

type PaginationProps = {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages === 0) return null

  const isFirst = currentPage === 1
  const isLast = currentPage === totalPages

  return (
    <div data-slot="pagination" className="flex items-center gap-2">
      <Button
        variant="outline"
        size="icon-sm"
        disabled={isFirst}
        onClick={() => onPageChange(1)}
        aria-label="First page"
      >
        <ChevronsLeft />
      </Button>
      <Button
        variant="outline"
        size="icon-sm"
        disabled={isFirst}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft />
      </Button>
      <span className="px-2 text-sm text-muted-foreground">
        Page {currentPage} of {totalPages}
      </span>
      <Button
        variant="outline"
        size="icon-sm"
        disabled={isLast}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        <ChevronRight />
      </Button>
      <Button
        variant="outline"
        size="icon-sm"
        disabled={isLast}
        onClick={() => onPageChange(totalPages)}
        aria-label="Last page"
      >
        <ChevronsRight />
      </Button>
    </div>
  )
}

export { Pagination }
export type { PaginationProps }
